import { render, staticRenderFns } from "./PanelCompetitionSettingStatement.vue?vue&type=template&id=93fe08e4&scoped=true&"
import script from "./PanelCompetitionSettingStatement.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingStatement.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingStatement.vue?vue&type=style&index=0&id=93fe08e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fe08e4",
  null
  
)

export default component.exports